if (!window.rimAddToCartEarlyBound) {
    window.rimAddToCartEarlyBound = true;
    window.rimAddToCartReady = false;

    document.addEventListener("submit", function(event) {
        var form = event.target;
        if (!form || !form.classList || !form.classList.contains("rim-add-to-cart-form")) {
            return;
        }

        if (window.rimAddToCartReady) {
            return;
        }

        event.preventDefault();
        form.setAttribute("data-add-to-cart-early-submit", "true");

        var buttons = form.querySelectorAll("button[type=submit], input[type=submit]");
        for (var i = 0; i < buttons.length; i++) {
            buttons[i].disabled = true;
        }
    }, true);
}
